import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Logo, loader_image } from "../_components/Imagepath";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import { base_url, Apitoken, Authtoken } from "../Global";
// import { generatePdf } from "../supplychainpackagelistheaders/DailyReportPDF";
// import html2canvas from 'html2canvas';
// import { saveAs } from 'file-saver';
import $ from "jquery";

// // import React from 'react';
// import html2pdf from 'html2pdf.js';
// import JsPDF from 'jspdf';
import { useRef } from 'react';

// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
// import Pdf from 'react-to-pdf';

const ViewInvoice = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [invtype, setInvtype] = useState(false);
  const ref = useRef();
  let season_id = localStorage.getItem("season_id");

  const [currencySymbol, setCurrencySymbol] = useState('');
  useEffect(() => {
    axios
      .get(`/invoices/view/${season_id + '-' + id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log(response);

        if (response.data.code === 200) {

          if (response.data.data.invoice.invoice_type == 1) {
            setInvtype(true);
          }

          setValue(response.data.data.invoice);
          axios.get(`/helper/currency-by-customer/${response.data.data.invoice.customer_id}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          }).then((response) => {
            if (response.data.code === 200) {
              // console.log(response.data.data);
              setCurrencySymbol(response.data.data.customer_currency)

            }
          }).catch((error) => {
            console.log(error);
          });
          // if(response.data.data.invoice.invoice_type == 3 || response.data.data.invoice.invoice_type == 1){
          //   axios .get(`/helper/currency-by-customer/${response.data.data.invoice.customer_id}`, {
          //     headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          //   }) .then((response) => {
          //     if (response.data.code === 200) {
          //      // console.log(response.data.data);
          //       setCurrencySymbol(response.data.data.customer_currency)

          //     }
          //   }) .catch((error) => {
          //     console.log(error);
          //   });
          // }else{
          //   axios.get(`/helper/currency-by-order/${season_id+'-'+response.data.data.invoice.order}`, {
          //     headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          //   })
          //   .then((response) => {
          //     if (response.data.code === 200) {
          //     // console.log(response.data.data);
          //       setCurrencySymbol(response.data.data.customer_currency)

          //     }
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });
          // }

        }
      })
      .catch((error) => {
        console.log(error);
      });


    // axios
    //   .get(`/invoices/view-download/${season_id + '-' + id}`, {
    //     headers: {
    //       Authorization: `Bearer ${Authtoken}`,
    //       Apitoken: Apitoken,
    //     },
    //   })
    //   .then((response) => {
    //     if (response.data.code === 200) {
    //       console.log(response.data.data.invoice);
    //       // setApiData(response.data.data.invoice);
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };




  const handleDownloadPDF = async (value) => {
    var invoice_id = value.id;
    let season_id = localStorage.getItem("season_id");
    console.log("value");
    console.log(value);
    $("#loader-image").removeClass('loader-hide');
    $("#loader-image").addClass('loader-show');
    axios.get(`/invoices/finance-sale-invoice/${season_id + '-' + invoice_id}`, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      // let file_name = value.invoice_number +'.pdf';
      const po_order_number = value.po_order_number || '';
      const invoicenumber = value.invoice_number || '';
      const company_name = value.customer?.company_name || 'Unknown';
      let file_name = invoicenumber + " " + company_name + ' ' + po_order_number + '.pdf';
      link.download = file_name;
      link.click();
      $("#loader-image").addClass('loader-hide');
      $("#loader-image").removeClass('loader-show');
    })
      .catch(error => {
        console.error('Error downloading PDF:', error);
      });
  };

  const handleDownloadExcel = async (value) => {
    console.log(value);
    let season_id = localStorage.getItem("season_id");

    window.open(`${base_url}/invoices/view-download-excel-open/${season_id + '-' + id}`, '_blank');

  };


  const handleDownloadPDFPackagingList = async (value) => {

    console.log("value");
    console.log(value);

    let season_id = localStorage.getItem("season_id");

    $("#loader-image-invoice2").removeClass('loader-hide');
    $("#loader-image-invoice").addClass('loader-show');
    var invoice_id = value.id;
    axios.get(`/invoices/view-download-pdf/${season_id + '-' + invoice_id}`, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);

      const po_order_number = value.po_order_number || '';
      const invoicenumber = value.invoice_number || '';
      const company_name = value.customer?.company_name || 'Unknown';

      let file_name = invoicenumber + " " + company_name + ' ' + po_order_number + '.pdf';
      //  let file_name = value.invoice_number +'.pdf';
      link.download = file_name;
      link.click();
      $("#loader-image-invoice2").addClass('loader-hide');
      $("#loader-image-invoice2").removeClass('loader-show');
    })
      .catch(error => {
        console.error('Error downloading PDF:', error);
      });
  };
  const generatePdfInvoiceDownloadExcel = async (invoice) => {
    let season_id = localStorage.getItem("season_id");

    window.open(`${base_url}/invoices/view-download-excel-open/${season_id + '-' + invoice.id}`, '_blank');

  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-10">
                  <h3 className="page-title">View Invoice</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/invoices">Invoice</Link>
                    </li>
                    <li className="breadcrumb-item active">View Invoice</li>
                  </ul>
                </div>
                <div className="col-sm-2">
                  <div className="pull-right">

                    {value.packaging_list_id != 0 && (
                      <div style={{ display: 'flex' }}>
                        <button onClick={() => handleDownloadPDFPackagingList(value)} className="btn btn-primary me-1"  > Download PDF  <i className="fa fa-download" /> <img id="loader-image-invoice2" className="loader-image loader-hide" src={loader_image} />  </button>
                        <button onClick={() => generatePdfInvoiceDownloadExcel(value)} className="btn btn-primary me-1"  > Download Excel  <i className="fa fa-pdf" /> <img id="loader-image-invoice2" className="loader-image loader-hide" src={loader_image} />  </button>

                      </div>

                    )}

                    {value.packaging_list_id == 0 && (
                      <div style={{ display: 'flex' }}>
                        <button onClick={() => handleDownloadPDF(value)} className="btn btn-primary me-1"  >  Download Sale Invoice  <i className="fa fa-download" /> <img id="loader-image" className="loader-image loader-hide" src={loader_image} />  </button>

                        <button onClick={() => handleDownloadExcel(value)} className="btn btn-primary me-1"  > Download Excel  <i className="fa fa-pdf" /> <img id="loader-image-invoice3" className="loader-image loader-hide" src={loader_image} />  </button>
                      </div>

                    )}



                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-12" id="printablediv">
                <div className="card" ref={ref} style={{ width: '100%' }}  >
                  <div className="card-body">
                    <div className="invoice-item">
                      <div className="row">
                        <div className="col-md-6">
                          {/* <p className="">
                            <strong>EXPORTER:</strong> LIBAN FRESH <br />
                            <strong>INVOICE PARTY:</strong> EXPORT OPTIMUM
                          </p> */}
                        </div>
                        <div className="col-md-6">
                          {/* <p className="invoice-details">
                            <strong>Invoice N°:</strong> {value.invoice_number}{" "}
                            <br />
                            <strong>Date:</strong> {value.date}
                          </p> */}
                        </div>
                      </div>
                    </div>

                    <div className="invoice-item">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="invoice-info">
                            <div className="invoice-logo-">
                              <img src={Logo} alt="logo" style={{ width: "100px", height: '110px' }} />
                            </div>
                            <strong className="customer-text">
                              {value.invoicetype
                                ? value.invoicetype.title
                                : "Invoice"}  From
                            </strong>
                            <p className="invoice-details invoice-details-two">
                              EXPORT OPTIMUM
                              <br /> DOUAR MOUARAA TEYARA <br />
                              LAAOUAMRA KSAR EL KEBIR

                              <br />
                              Phone: 00212678732391 <br />

                            </p>
                          </div>
                        </div>
                          <div className="col-md-4"></div>
                        {value.customer_type == 'invoice' ? (
                          <div className="col-md-4">
                            <div className="invoice-info invoice-info2">
                              <p className="invoice-details">
                                <strong>Invoice N°:</strong> {value.invoice_number}{" "}
                                <br />
                                <strong>Date:</strong> {value.date}
                              </p>
                              <strong className="customer-text ">
                                {value.invoicetype
                                  ? value.invoicetype.title
                                  : "Invoice"} To
                              </strong>
                              <p className="">
                                {value.customer_id
                                  ? value.customer.company_name
                                  : ""}
                                <br />
                                {/* {value.invoicing_address
                                  ? value.invoice_address.email
                                  : ""}
                                <br /> */}
                                {value.invoicing_address
                                  ? value.invoice_address.phone_number
                                  : ""}  {', '}
                               
                                {value.invoicing_address
                                  ? value.invoice_address.address
                                  : ""} {', '}
                            
                                {value.invoicing_address
                                  ? value.invoice_address.city
                                  : ""} {', '}
                                {value.invoicing_address
                                  ? value.invoice_address.zip_code
                                  : ""}{', '}
                                {value.invoicing_address
                                  ? value.invoice_address.country_name
                                  : ""} {', '}
                              
                              
                              </p>

                              <p>
                                Incoterms:{" "}{value?.customer?.incoterm_name?.title || ""} {', '}
                                
                                Payment Terms:{" "}
                                {value?.customer?.payment_terms?.delay1_description || ""}

                              </p>  
                               <p>
                                {invtype && (
                                  <p>ICE:  {value.ice}</p>
                                )}
                                {invtype && (
                                  <p>IF: {value.if}</p>
                                )}
                              </p>

                            </div>
                          </div>
                        ) : (
                          <div className="col-md-4">
                            <div className="invoice-info invoice-info2">
                              <p className="invoice-details">
                                <strong>Invoice N°:</strong> {value.invoice_number}{" "}
                                <br />
                                <strong>Date:</strong> {value.date}
                              </p>
                              <strong className="customer-text ">
                                {value.invoicetype
                                  ? value.invoicetype.title
                                  : "Invoice"} To
                              </strong>
                              <p className="">
                                {value.customer
                                  ? value.customer.name
                                  : ""}<br />

                                {value.customer
                                  ? value.customer.phone_number
                                  : ""}<br />
                                {value.customer
                                  ? value.customer.address
                                  : ""}<br />



                                {invtype && (
                                  <p>ICE:  {value.ice}</p>
                                )}
                                {invtype && (
                                  <p>IF: {value.if}</p>
                                )}
                              </p>

                            </div>
                          </div>
                        )}


                      </div>
                    </div>

                    <div className="invoice-item invoice-table-wrap">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="table-responsive">
                            <table className="invoice-table table table-bordered">
                              <thead>
                                <tr>
                                  {invtype === false && (<th>Code</th>)}
                                  {invtype === false && (<th>Product</th>)}
                                  {invtype && (
                                    <th>Description</th>
                                  )}
                                  <th className="text-center">Quantity (kg)</th>
                                  <th className="text-end">Price (Euro/Kg)</th>
                                  <th className="text-end">Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {value.items &&
                                  value.items.map((item) => (
                                    <tr key={item.id}>
                                      {invtype === false && (
                                        <td>  {item.product_type_category
                                          ? item.product_type_category.code
                                          : ""}
                                        </td>
                                      )}
                                      {invtype === false && (
                                        <td>
                                          {item.product_type_category
                                            ? item.product_type_category.product_name
                                            : ""} {item.calibre}
                                        </td>
                                      )}

                                      {invtype && (
                                        <td className="">
                                          {item.calibre}
                                        </td>
                                      )}


                                      <td className="text-center">
                                        {item.quantity}
                                      </td>
                                      <td className="text-end">
                                        {Number(item.price).toFixed(4)}{currencySymbol}
                                      </td>
                                      <td className="text-end">
                                        {item.amount}{currencySymbol}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-md-6 col-xl-4 ms-auto">
                          <div className="table-responsive">
                            <table className="invoice-table-two table">
                              <tbody>
                                <tr>
                                  <th>Amount:</th>
                                  <td>
                                    <span>{value.total_amount}{currencySymbol}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th>Tax:</th>
                                  <td>
                                    <span>{value.tax}{currencySymbol}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th>Discount:</th>
                                  <td>
                                    <span>{value.discount}{currencySymbol}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th>Final Amount:</th>
                                  <td>
                                    <span>{value.net_amount}{currencySymbol}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewInvoice;
